import { Observable } from 'rxjs';
import { CustomerStatus } from '../../domain';
import {
  CreateProspectCustomerResponse,
  GatewayInputValidity,
  LoginForOneTimeCodeResponse,
  PrimaryCredentialInputValidity,
} from '../interfaces';

export abstract class AbstractGatewayService {
  public abstract signup(
    primaryCredential: string,
    options?: {
      voucher?: string;
      campaign?: string;
      bin?: string;
      oneTimeCode?: string;
    }
  ): void;

  public abstract login(options?: { primaryCredential?: string; oneTimeCode?: string; voucherCode?: string }): void;

  public abstract getCurrentProfilePersonaId$(): Observable<string>;

  public abstract getCustomerStatus$(): Observable<CustomerStatus>;

  public abstract createLeadCustomer$(primaryCredential: string): Observable<PrimaryCredentialInputValidity>;
  public abstract createProspectCustomer$(primaryCredential: string, password: string): Observable<CreateProspectCustomerResponse>;
  public abstract loginForOneTimeCode$(primaryCredential: string, password: string): Observable<LoginForOneTimeCodeResponse>;
  public abstract validateVoucherCode$(voucherCode: string, primaryCredential?: string): Observable<GatewayInputValidity>;
  public abstract validateBIN$(cardNumber: string, primaryCredential?: string): Observable<GatewayInputValidity>;
}
